import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Cookies from 'js-cookie';
import Content from './Content.js';
import { c as commonPropTypes } from './commonPropTypes-8c108b82.js';
import { S as SvgCloseCircle } from './close-circle-60d2e5fd.js';
import { S as SvgInfoHollowIcon } from './info-hollow-icon-766cf178.js';
import './_rollupPluginBabelHelpers-c7687d88.js';
import './types-6e7da022.js';

var styles = {"component":"InfoBanner-module_component__2Snan","visible":"InfoBanner-module_visible__useWa","content":"InfoBanner-module_content__4GcL6","infoBox":"InfoBanner-module_infoBox__XSJib","body":"InfoBanner-module_body__3kQvT","title":"InfoBanner-module_title__MyA-e","icon":"InfoBanner-module_icon__3p73B","close":"InfoBanner-module_close__3M3pi","text":"InfoBanner-module_text__3h6Tu"};

const InfoBanner = ({
  children = null,
  className,
  icon = /*#__PURE__*/React__default.createElement(SvgInfoHollowIcon, null),
  id,
  interval = 7,
  // days
  ssrVisible = false,
  title = null,
  titleClassName,
  visibleClassName
}) => {
  const [isVisible, setVisible] = useState(ssrVisible);
  const COOKIE_ID = `infoBanner-${id}`;
  useEffect(() => {
    const cookie = Cookies.get(COOKIE_ID);
    const status = cookie && JSON.parse(cookie) || {};
    const visible = COOKIE_ID !== status.id;
    setVisible(visible);
  }, [COOKIE_ID]);
  return /*#__PURE__*/React__default.createElement(Content, {
    className: styles.content,
    wrapper: {
      className: cx('mw-infoBox-wrapper', styles.component, {
        [styles.visible]: isVisible,
        [visibleClassName]: isVisible
      })
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.infoBox
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cx(styles.body, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cx(styles.title, titleClassName)
  }, icon && /*#__PURE__*/React__default.cloneElement(icon, {
    className: cx(styles.icon, icon.props.className)
  }), title, /*#__PURE__*/React__default.createElement(SvgCloseCircle, {
    className: styles.close,
    onClick: () => {
      setVisible(false);
      Cookies.set(COOKIE_ID, {
        id: COOKIE_ID
      }, {
        expires: interval
      });
    }
  })), children && /*#__PURE__*/React__default.createElement("div", {
    className: styles.text
  }, children))));
};
InfoBanner.propTypes = {
  children: PropTypes.node,
  className: commonPropTypes.className,
  icon: PropTypes.node,
  id: PropTypes.string.isRequired,
  interval: PropTypes.number,
  ssrVisible: PropTypes.bool,
  title: PropTypes.node,
  titleClassName: commonPropTypes.className,
  visibleClassName: commonPropTypes.className
};

export { InfoBanner as default };
